import React, { useEffect } from 'react';

import { Box, Button, Divider, Stack } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import ReactHookFormDragnDropFile from 'common/components/form/ReactHookFormDragnDropFile';
import ReactHookFormSelect from 'common/components/form/ReactHookFormSelect';
import yupResolver from 'common/utils/yupResolver';

import * as actions from '../actions';
import * as selectors from '../selectors';
import validate from '../validate';

const FormContainer = ({
    documentsTypeToSelect,
    handleClickCancel,
    initialValues,
    isUploading,
    save,
}) => {
    const { t } = useTranslation();

    const { control, handleSubmit, reset, setValue, watch } = useForm({
        defaultValues: initialValues,
        resolver: yupResolver(validate),
    });

    useEffect(() => reset(initialValues), [initialValues]);

    const formValues = watch();

    const handleSave = (values) => save(values);

    return (
        <Stack component="form" onSubmit={handleSubmit(handleSave)}>
            <ReactHookFormSelect
                control={control}
                disabled={
                    formValues.id !== null &&
                    typeof formValues.id !== 'undefined'
                }
                label={t('Document type')}
                name="catalog_document"
                options={documentsTypeToSelect}
            />

            <ReactHookFormDragnDropFile
                control={control}
                name="file"
                setValue={setValue}
                text={t('Attach file')}
            />

            <Divider sx={{ mx: (theme) => `${theme.spacing(-2)}!important` }} />

            <Box sx={{ display: 'flex', gap: 2, justifyContent: 'end' }}>
                <Button
                    color="secondary"
                    onClick={handleClickCancel}
                    type="button"
                    variant="text"
                >
                    {t('Cancel')}
                </Button>

                <Button
                    disabled={isUploading}
                    type="submit"
                    variant="contained"
                >
                    {t('Save')}
                </Button>
            </Box>
        </Stack>
    );
};

FormContainer.propTypes = {
    documentsTypeToSelect: PropTypes.array,
    handleClickCancel: PropTypes.func,
    initialValues: PropTypes.object,
    isUploading: PropTypes.bool,
    save: PropTypes.func,
};

const mapStateToProps = createStructuredSelector({
    initialValues: selectors.getInitialValues,
    isUploading: selectors.getIsUploading,
});

const mapDispatchToProps = (dispatch) => ({
    save: (values) => dispatch(actions.uploadFile(values)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FormContainer);
